 
class Disciplina {  


    public static campos = () => {
        return [  
            {
                nome: "descricao",
                type: "text",
                label: "Nome",
                sm: 12,
                lg: 6, 
                disabled: false
            },  
            {
                nome: "tipo",
                type: "select",
                label: "Tipo de disciplina",
                sm: 6,
                lg: 3, 
                disabled: false,
                options:  [ 
                    {value:"1",label:'Nota'},
                    {value:"2",label:'Apto/Inapto'}, 
                ]
            },  
            {
                nome: "status",
                type: "select",
                label: "Acesso (Status)",
                sm: 6,
                lg: 3, 
                disabled: false,
                options:  [ 
                    {value:"1",label:'NORMAL'},
                    {value:"2",label:'LIBERADA_NOTA'}, 
                ]
            },  
            {
                nome: "cargaHoraria",
                type: "number",
                label: "Carga Horária",
                sm: 12,
                lg: 3, 
                disabled: false
            },  
            {
                nome: "cargaHorariaLimpa",
                type: "number",
                label: "Carga Horária para Falta",
                sm: 12,
                lg: 3, 
                disabled: false
            },  
            {
                nome: "qteLimiteFalta",
                type: "number",
                label: "Limite de Falta",
                sm: 12,
                lg: 3, 
                disabled: false
            },  
            {
                nome: "peso",
                type: "number",
                label: "Peso",
                sm: 12,
                lg: 3, 
                disabled: false
            },   
            {
                nome: "quantiadadeAvaliacao",
                type: "number",
                label: "Qt de avaliações",
                sm: 12,
                lg: 3, 
                disabled: false
            },  
            {
                nome: "quantidadeTrabalho",
                type: "number",
                label: "Qt de Trabalhos",
                sm: 12,
                lg: 3, 
                disabled: false
            },  
            
            {
                nome: "ordem",
                type: "number",
                label: "Ordem",
                sm: 12,
                lg: 3, 
                disabled: false
            },  
            
            
            {
                nome: "isSomatorio",
                type: "checkbox",
                label: "É somatório (marcar só se não for para tirar a média das notas)",
                sm: 12,
                lg: 5, 
                disabled: false
            },    
            {
                nome: "isToNaoCalcularVf",
                type: "checkbox",
                label: "Não Incluir para calculo do porcentual das VF",
                sm: 12,
                lg: 4, 
                disabled: false
            },   
            {
                nome: "isDisciplCondPess",
                type: "checkbox",
                label: "Conduta Profissional",
                sm: 12,
                lg: 3, 
                disabled: false
            },           
        ];
    }   
}
  
export   {   Disciplina };
